var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0764 1.875H5.10137C2.94512 1.875 1.65137 3.1625 1.65137 5.325V10.2937C1.65137 12.4625 2.94512 13.75 5.10137 13.75H10.0701C12.2326 13.75 13.5201 12.4625 13.5201 10.3V5.325C13.5264 3.1625 12.2326 1.875 10.0764 1.875Z",
    fill: "#2E37A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.539 1.86096C12.4203 0.735963 11.3265 0.710963 10.1765 1.86096L9.47028 2.56096C9.40778 2.62346 9.38903 2.71096 9.41403 2.79221C9.85153 4.32346 11.0765 5.54846 12.6078 5.98596C12.6265 5.99221 12.6578 5.99221 12.6765 5.99221C12.739 5.99221 12.8015 5.96721 12.8453 5.92346L13.539 5.22346C14.1078 4.65471 14.389 4.11096 14.389 3.55471C14.389 2.99221 14.1078 2.43596 13.539 1.86096Z",
    fill: "#2E37A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5641 6.51094C11.3953 6.42969 11.2328 6.34844 11.0828 6.25469C10.9578 6.17969 10.8328 6.09844 10.7141 6.01094C10.6141 5.94844 10.5016 5.85469 10.3891 5.76094C10.3766 5.75469 10.3391 5.72344 10.2891 5.67344C10.0953 5.51719 9.88905 5.30469 9.6953 5.07344C9.6828 5.06094 9.6453 5.02344 9.61405 4.96719C9.55155 4.89844 9.4578 4.77969 9.37655 4.64844C9.3078 4.56094 9.22655 4.43594 9.15155 4.30469C9.0578 4.14844 8.97655 3.99219 8.90155 3.82969C8.8203 3.65469 8.7578 3.49219 8.70155 3.33594L5.33905 6.69844C5.1203 6.91719 4.9078 7.32969 4.86405 7.63594L4.5953 9.49844C4.53905 9.89219 4.6453 10.2609 4.88905 10.5047C5.0953 10.7109 5.37655 10.8172 5.68905 10.8172C5.7578 10.8172 5.82655 10.8109 5.8953 10.8047L7.75155 10.5422C8.0578 10.4984 8.4703 10.2922 8.68905 10.0672L12.0516 6.70469C11.8953 6.65469 11.7391 6.58594 11.5641 6.51094Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8242b016e99625ab2b0e11ffd5e54f96.svg";
export { ForwardRef as ReactComponent };